<!-- 更多资讯 -->
<template>
  <div class="container">
    <login-navigator></login-navigator>
    <logo-header></logo-header>
    <section class="bread">
      <span class="index">首页</span><span>&gt;</span><span class="current">热点资讯</span>
    </section>
    <section class="main">
      <div class="main-content">
        <ul>
            <router-link :to="{path:'news',query:{id:index}}" v-for="(item,index) in newsList" v-bind:key="index" >
                <li>
                    <div class="title">{{item.title}}</div>
                    <span class="time">{{item.time}}</span>
                </li>
            </router-link>
        </ul>
      </div>
    </section>
  </div>
</template>

<script>
import LoginNavigator from "../components/LoginNavigator";
import LogoHeader from "../components/LogoHeader";
export default {
  data() {
    return {
      newsList: [
        {
          title: "年轻人排队买的这款高性能、高颜值、高安全轿车，你买了吗?",
          time: "2017-03-23",
          pList: [
            "实践是检验整理的唯一标准，市场是检验一辆车好坏的不二法门。全新名爵6仅上市4个多月，变成为运动轿车市场的新巨头，年轻人都排队买了。并且，作为互联网性能座驾，其互联网版本占比超70%，追求性能的年轻人，同时也乐意享受互联网新生活，这一切，全新名爵6都能满足。但是，这就够了吗?",
            "显然是不够的，作为有着近百年竞速历史、崇尚Safety Fast的MG名爵，不仅快，也不仅融入网联基因，更难得的是“快而稳”。刚刚上市的全新名爵6 20T自动Trophy超级运动互联网版，就越级配备了MG PILOT智能主动驾驶辅助系统，并以满分成绩通过中国首次公开模拟真实交通路况的主动安全测试，回应年轻人“快即正义”的诉求。",
            "在全新名爵6刚亮相时，各种溢美言辞，让全新名爵6突然就火了，全新名爵6上市就被称为“感性力颜王”，“感性力颜王”一词，原来是说名爵6的。还有说其是“这一抹红，专为“真”运动时尚范儿而来”。可以说，全新名爵6做到了精准回应消费升级时代年轻消费者的高品质驾乘需求，自上市以来大热不止，是年轻人口中好看又好开的“高性能运动轿车本车”。",
            "世代都在为运动而生，全新名爵6自然不会差。凭借6秒级动力总成，百公里加速仅需6.6秒，名爵6搭载了一台搭载了“蓝芯高效动力科技”的1.5T涡轮增压发动机，动力达到了169马力，扭矩为250牛米，比思域的最大扭矩还大30牛米。",
            "爱玩爱浪、精力不限额的年轻人，有车以后活动半径更加大，对汽车的高性能和高安全性有更高追求。给年轻人“快而稳”的驾乘体验，是MG名爵一直以来坚持Safety Fast的体现。因此，全新名爵6在高性能的年轻激情驾控体验之外，于3月新添全新名爵6 20T自动Trophy超级运动互联网版，并领先思域、昂克赛拉等同级产品，“超前”主动单挑同步全球最高标准的主动安全测试，更进一步为年轻人提供最极致的安全保障。"
          ]
        },
        {
          title: "人工智能异军突起，中小学如何接招",
          time: "2018-04-04",
          pList: [
            "随着信息技术的发展，人工智能融入社会各行业和百姓生活中，中小学也掀起了一波“人工智能热”。今年两会期间，多位代表委员提出与人工智能相关的议案、提案，建议发展教育科技。“人工智能+教育”的话题日渐成为中小学校长和教育专家讨论的焦点。那么，人工智能进校园，会给中小学教育带来哪些机遇和挑战？",
            "科技信息素养是信息时代最基本的生存能力，在不少国家，科技信息技术教育已经上升到国家层面，英国、美国、澳大利亚等国家都对信息化技术制定了相应的课程标准。如，英国在2013年发布国家计算课程标准；美国则在2016年由计算机科学教师协会研制了“K-12计算机科学课程标准”等。",
            "2017年5月，国务院印发《新一代人工智能发展规划》（以下简称《规划》）提出,实施全民智能教育项目，在中小学校设置人工智能课程，推广编程教育，鼓励社会力量参与寓教于乐的编程教学软件、游戏的开发和推广，支持开展人工智能竞赛，鼓励进行形式多样的人工智能科普创作，鼓励科学家参与人工智能科普。教育部最新发布的高中新课程方案和课程标准，也将人工智能、物联网、大数据处理等内容列入其中。",
            "通过科技教育提升学生科技信息素养，成为学校培养未来社会人才的重要支点。在十三届全国人大一次会议新闻中心举办的记者会上，教育部部长陈宝生曾说道：“人工智能等异军突起，引起各方面的高度关注。这都要求我们对人才培养的模式进行改革、进行创新。这样我们才能培养起承担民族复兴大任一代新人的历史任务。”",
            "随着新技术的更新迭代，科技教育的形式也不断创新。北京大学教育学院教育技术系主任尚俊杰认为，促进科技教育的最好方法是“用科技”，人工智能的崛起，让科技教育如虎添翼。“不难看到，游戏化、VR（虚拟现实）、AR（增强现实）等科技技术在科技教育中的使用都增强了学生的上课体验与使用效果。”"
          ]
        },
        {
          title: "生态环境部向京津等二十市发督办函 要求公开问题清单",
          time: "2018-04-17",
          pList: [
            "法制网讯　记者郄建荣 京津冀大气污染传输通道城市即“2＋26”城市为期一年的强化督查已经结束，生态环境部近日向北京、天津等20个市政府发出组建后首批督办函，同时移交了督办问题清单。生态环境部要求收到督办问题后2个工作日内公开信息，否则或将量化问责。",
            "生态环境部向20个市政府发出督办函，要求地方政府高度重视督办问题整改落实工作，进一步调查核实有关情况，加大工作力度，严格规范要求，确保督办的各类问题按要求完成整改。",
            "对督办后仍推进缓慢的，整改落实不到位的，应当立案处罚而未处罚的，虚报、瞒报问题突出的，未按《信息公开方案》要求公开相关信息的，以及其他纳入量化问责情形范围的，生态环境部将依照《京津冀及周边地区2017－2018年秋冬季大气污染综合治理攻坚行动量化问责规定》提出问责建议。"
          ]
        },
        {
          title: "中国便利店行业连续7年增长 苏宁收购迪亚抢占风口",
          time: "2018-04-19",
          pList: [
            "4月3日晚间，迪亚天天发布公告称，就出售迪亚中国 股权事项，公司已与苏宁签订了有约束力的购买与出售协议。据悉，在获得政府部门的审批并完成收购之后，苏宁易购将输出智慧零售解决方案，对后者进行多方面的赋能与升级，加速苏宁小店在上海地区的布局和落地。",
            "对于此项收购，苏宁零售集团副总裁卞农表示，迪亚在上海拥有约250万会员，有超过300家门店密集布于上海主城区，且基本均处于社区商圈，与苏宁小店的社区定位一致，该类门店网络具备稀缺性，一次性获取可大幅减少苏宁的时间成本和资源投入。另一方面，迪亚中国有相对成熟的运营体系，也将助力苏宁小店快速切入上海市场。",
            "完成收购之后，苏宁将输出智慧零售模式，整合苏宁线下线上融合的服务能力、苏宁八大产业会员资源，及其在互联网大数据营销方面的优势，协同提升其运营效率，将苏宁小店快速推广到上海各个社区，为用户随时随地提供 的购物体验。",
            "据悉，苏宁与迪亚国际还拟商讨开展在进出口商品与供应链方面的战略合作，资源互补，利用迪亚国际的海外供应链资源和苏宁在中国市场的渠道优势，苏宁可以为迪亚国际的供应商在中国提供分销渠道及定制服务，迪亚国际为苏宁引进欧洲的优质产品，并将为中国优质产品拓展国际市场提供服务。",
            "对于苏宁而言，收购迪亚仅仅只是开始，它是快速推进苏宁小店在全国重点城市布局，建立本地化的商品供应链体系，进一步丰富苏宁智慧零售经营场景的一次重要举措。就在此前的3月31日这天，133家苏宁小店在43座城市开业。",
            "苏宁小店是苏宁易购集团在“社区O2O”领域的新尝试，采用“便利店+App”模式，由实体门店和独立App结合而成。和传统便利店主打快消品不同的是，苏宁小店向消费者提供以快消和生鲜为代表的全品类商品和1公里范围内 快30分钟急速配送的服务，以及家电维修、家电清洗、家政、快递代收等便民社区服务，主要满足区域消费者在 后一公里对购物、餐饮、闪送等生活购物和日常服务的需求，尤其要解决周边消费者的一日三餐。",
            "据《2017中国便利店发展报告》数据显示，中国连锁品牌化便利店门店数接近10万家，销售达1300亿。从2010年起连续7年的时间里，中国便利店行业销售额一直保持两位数增长，且从2011年起，就超越了百货和超市等其他零售业态的增速。",
            "而苏宁在这方面有着先天的优势。在O2O商业零售领域有着28年积累的苏宁，从2017年开始布局社区商业生态，“基于乐观预测，未来三年，我们将成为中国 的O2O社区小店运营商，让原来的社区小店插上互联网的翅膀。”苏宁零售集团副总裁卞农今年3月的一个发布会上，向行业阐述了小店的定位和目标。"
          ]
        },
        {
          title: "新规！5月1日起高铁上吸烟者将禁止乘坐火车",
          time: "2018-04-20",
          pList: [
            "5月1日起，两部与市民出行相关的新规将开始实施，对火车逃票、违规吸烟、机场闹事等交通出行失信行为的处罚加码。根据新规，在动车组列车或其他列车的禁烟区域内吸烟，将被处以180天内禁止乘坐火车，而在机场、飞机上的“闹事者”也将被给予一年内禁止乘坐飞机的处罚。",
            "3月中旬，国家发改委等部门联合下发《关于在一定期限内适当限制特定严重失信人乘坐火车推动社会信用体系建设的意见》和《关于在一定期限内适当限制特定严重失信人乘坐民用航空器推动社会信用体系建设的意见》。",
            "重案组37号(微信ID：zhonganzu37)发现，两份规定并非首次针对“交通不文明”现象亮剑，早在2017年1月，国家发改委、交通运输部、公安部、民航局、铁路总公司等5部门就曾联合发布《关于加强交通出行领域信用建设的指导意见》(简称《意见》)，建议对交通失信行为实施联合惩戒，使交通领域不文明行为与其他领域的信用情况“挂钩”"
          ]
        },
        {
          title: "中国会为俄造航母吗？美媒:对中国好处显而易见",
          time: "2018-04-30",
          pList: [
            "美国《国家利益》双月刊网站4月27日刊载题为《中国会为俄罗斯造航母吗？》的文章称，为俄罗斯建造航母将促进未来建造航母所需要的基础设施和人力资本的发展；有助于巩固莫斯科-北京正在形成的安全关系，深入了解俄罗斯希望安装在航母上的专利技术；同时还能丰富中国在国际战舰制造市场的行政管理经验",
            "文章称，俄罗斯“库兹涅佐夫海军元帅”号航空母舰已到了必须大修的时期。最近在部署叙利亚沿海的行动中，航母性能不佳。除了引擎毛病，飞行甲板也有问题。在整个服役期间，“库兹涅佐夫海军元帅”号航空母舰的备战状态一直很差，主要是因为缺乏经验和维修经费。鉴于航母已服役近三十年，不知俄罗斯海军还能想方设法让它再服役多少年",
            "不过，文章指出，近期没有理由指望更换新航母。虽然有时宣称新航母即将建成，但是真正的设计工作尚未开始。此外，在紧缩防务开支时期，俄罗斯对海面舰队的重视程度似乎在下降。即使俄罗斯想造航母，也完全不清楚它是否能在合理的时间框架内完成任务"
          ]
        },
        {
          title: "各行业“亏损王”曝光 38家公司连续两年隐形亏损",
          time: "2018-04-30",
          pList: [
            "伴随着2017年A股上市公司年报的正式收官，乐视网以139亿元的亏损额登顶新的“亏损王”。过去一年不仅亏掉了7年净利润，乐视网2018年一季度再亏3亿元，退市风险隐现。二级市场上，今年以来乐视网市值蒸发7成，令投资者损失惨重",
            "包括乐视网在内，一共有220家A股上市公司2017年年报业绩亏损，此外还有38家公司连续两年隐形亏损且2018年一季度继续亏损。业绩地雷随时都可能引爆，你躲过了么？",
            "统计显示，目前A股3513家上市公司中，除9家公司因自身原因未披露年报外，有220家公司2017年净利润为负，数量与2016年基本持平，合计亏掉1221元。",
            "时间拉长来看，连续两年隐形亏损的上市公司也有107家，若无各项补贴、投资收益等等，可能就要被ST了。其中，有38家在2018年一季度还在继续亏损，7家公司一季度亏损过亿，有华东科技、同方股份这样的科技股，也有房地产公司嘉凯城。 据《21世纪经济报道》"
          ]
        },
        {
          title: "美电信运营商：让我们合并 美就能在5G上打赢中国",
          time: "2018-05-01",
          pList: [
            "据路透社4月30日报道，美国第三、四大电信运营商T-Mobile US和斯普林特（Sprint）达成了260亿美元（约合人民币1646.5亿元）的全股合并协议，他们自信可以获得监管当局的批准，免于反垄断法的制裁，因为他们声称合并有助于美国在5G网络的建设上击败中国。",
            "包括乐视网在内，一共有220家A股上市公司2017年年报业绩亏损，此外还有38家公司连续两年隐形亏损且2018年一季度继续亏损。业绩地雷随时都可能引爆，你躲过了么？",
            "据了解，T-Mobile和Sprint的大股东分别是德国电信和日本软银集团。其中，德国电信持有T-Mobile约65%的股份，而软银则持有Sprint约83%的股份。",
            "报道称，双方经过四年的磋商终于达成协议，这将打造一家拥有1.27亿客户的庞大企业，成为美国前两大电讯商威瑞森通讯（VZ.N）及美国电话电报公司（AT&T）更强大的竞争对手，合并后的公司将称为T-Mobile。",
            "T-Mobile方面则称，未来三年，他们会投资400亿美元来升级网络，以适应下一代5G无线技术的需要。新交易将打造美国最大容量的网络，降低价格，创造就业岗位并改善乡村地区的服务，这有助于美国5G网络的建设和领先。"
          ]
        },
        {
          title: "文在寅：诺贝尔和平奖给特朗普吧 我只想要和平",
          time: "2018-05-01",
          pList: [
            "[文/观察者网]27日，朝韩两国领导人在板门店举行了峰会，这是战后朝鲜最高领导人首次踏上韩国土地。对此，曾经获得过诺贝尔和平奖的韩国前总统金大中的遗孀认为，文在寅值得一座诺贝尔。而文在寅则并不在意，反而推荐了美国总统特朗普。",
            "据韩国韩国广播公司（KBS）30日报道，韩国前总统金大中的遗孀李姬镐对成果丰硕的朝韩峰会发出了贺信，她称文在寅在朝韩峰会中表现卓越，希望他可以获得一座诺贝尔奖。在2000年的时候，韩国前总统金大中就曾经因为举行了首次朝韩领导人峰会而获得了诺贝尔和平奖。",
            "据了解，T-Mobile和Sprint的大股东分别是德国电信和日本软银集团。其中，德国电信持有T-Mobile约65%的股份，而软银则持有Sprint约83%的股份。",
            "对于诺贝尔和平奖一事，美国总统特朗普一直强调自己做出了巨大的贡献。而且很多美国民众与美国高官也认为特朗普值得一座诺贝尔和平奖。当地时间28日晚，特朗普在举行政治集会的时候，就有大量民众在台下高呼“诺贝尔！”"
          ]
        },
        {
          title: "与高管有冲突 WhatsApp联合创始人将离开Facebook",
          time: "2018-05-01",
          pList: [
            "新浪科技讯 北京时间5月1日早间消息，据《华盛顿邮报》网站报道，通信服务WhatsApp联合创始人简·库姆（Jan Koum）将从WhatsApp母公司Facebook离职。",
            "《华盛顿邮报》援引匿名消息人士的言论称，库姆之所以选择离开Facebook，是因为他与该公司高管在WhatsApp发展策略的问题上发生了冲突。Facebook试图使用WhatsApp的个人数据，并弱化其加密性。",
            "库姆与布莱恩·阿克顿（Brian Acton）在2017年联合创立了WhatsApp，并于2014年以190多亿美元的价格将其出售给了Facebook，阿克顿则已在2017年离开Facebook。据《华盛顿邮报》报道，库姆计划退出Facebook董事会，但离职的具体时间尚属未知。报道刊出后，库姆在Facebook上发帖证实他将离职。",
            "消息传出以后，Facebook股价在美股市场周一盘后的交易中平走，此前其股价在常规交易中收盘下跌不到1%，报172美元。过去三个月里Facebook股价已累计下跌8%，相比之下同期标普500指数下跌5.4%。(唐风)"
          ]
        },
        {
          title: "腾讯游戏:“王者荣耀对部分手机负优化”言论不实",
          time: "2018-05-08",
          pList: [
            "腾讯游戏表示，腾讯游戏不存在任何对手机终端“负优化”的操作。所谓“负优化”不仅会极大伤害用户体验，影响产品口碑，同时会徒增很多不必要的人力成本。一直以来，我们都怀着尊重甚至是敬畏的态度来对待“用户体验”。我们不会，也没有理由进行此类损害各方利益，有违商业逻辑的操作。",
            "同时，腾讯游戏称，王者荣耀及腾讯游戏从未与任何手机厂商在技术层面进行付费合作，更不存在“巨额保护费”一说。目前腾讯游戏所有技术优化方案都是完全开放且免费的，完全不存在封闭化、特殊化的技术合作，手机厂商可以通过正规合作渠道按照协议标准接入。只要有利于优化用户体验，推动解决技术难题，我们愿意与游戏上下游产业共同推动行业健康发展。",
            "针对部分用户手机出现闪退、掉帧等问题，腾讯游戏称，2017年4月20日，王者荣耀【命运结契】版本更新后，我们收到了部分玩家对闪退、掉帧、卡顿等问题的反馈，随后立即进行了紧急定位及修复，并于4月28日在安卓/iOS端上架了修复版本。目前，多数玩家的卡顿、掉帧、闪退问题已经优化，但部分玩家仍表示更新后依然存在问题，后续我们会持续收集相关案例定位问题，尽快修复保障玩家的游戏体验。事实证明，近期突然出现的闪退、掉帧、卡顿现象与版本更新有关，与所谓“负优化”无关。",
            "对于接下来在优化手游用户体验方面的规划，腾讯游戏方面表示，目前腾讯游戏正在重点与包括OPPO、VIVO、华为(含荣耀)和小米在内的主流安卓手机厂商及芯片厂商针对热门游戏进行性能优化技术攻关。计划在近期技术条件成熟后，将对外开放交互协议和引擎接口，进一步扩大合作范围，让与游戏业务关联厂商均能共同优化玩家的游戏体验。"
          ]
        },
        {
          title: "“全民公敌”携程：危险在一步步逼近",
          time: "2018-05-08",
          pList: [
            "梁建章用资本拿下对手之后，没能换得一片清净，携程陷入持续的舆论漩涡，甚至被打上“全民公敌”的标签。被如此诟病，皆因其捆绑销售、高价退改签、大数据杀熟等做法，声讨者有普通用户，也有作家蒋方舟、演员韩雪、微博大V王志安等名人。",
            "一片质疑声中，梁建章少见回应，作为携程董事局主席的他更多是以人口经济学家身份出现，出口必谈人口学，少谈或不谈携程。",
            "看起来，现在不是携程最危险的时刻。2013年梁建章回归前，携程腹背受敌，遭到包括去哪儿、艺龙在内的对手的猛烈进攻，市值跌至32亿美元，被剔除出纳斯达克100指数。而现在，携程市值超过200亿美元。",
            "“当时的携程是一艘千疮百孔的航空母舰，很多高管拿到的期权行权价比市价还贵，不如白纸。在携程高管看来，目前的形势并没有当年那么危急。”一位接近携程的人士告诉《中国企业家》。",
            "接受采访的大多数行业人士认为，携程并非看不到持续不断的舆论危机，只是作为中国在线旅游市场的一家独大者，携程更关注的是收入、股价与利润。",
            "除了声誉与品牌，携程的收入与股价也面临挑战。",
            "015年10月26日一早，梁建章走出北京国贸中心大厦，长舒一口气。刚刚，他经历了48小时几乎没睡的高强度谈判，总算谈成了。当晚，携程去哪儿合并的消息就传遍网络。这是一次改变格局的合并，依据当时的行业数据，携程借此获得在线旅游市场70%的份额。",
            "合并让问题似乎变得简单。“消灭竞争之后，携程开启了以利润为中心的管理方式。”前述接近携程的人士回忆，与去哪儿竞争期间，要抢市场份额，携程很少做出影响用户体验的事情。合并之后，携程一家独大，捆绑销售这样的产品形态开始高频出现。用户局限于使用频次，感知需要过程，这也是最近一两年频频爆出的原因。"
          ]
        },
        {
          title: "三星S9现身GeekBench跑分网站：运行安卓8.1系统",
          time: "2018-05-08",
          pList: [
            "5月7日， 三星Galaxy S9现身GeekBench跑分网站，该机运行的是安卓8.1系统，我们知道三星S9系列预装的是安卓8.0系统。由此推测， 三星S9安卓8.1系统正在开发中，距离正式发布已经不远了。",
            "Galaxy S9是三星在西班牙MWC2018展会上推出的新一代旗舰，该机采用了5.8英寸全视曲面屏，分辨率为2960×1440，屏幕纵横比为18.5：9。",
            "它搭载高通骁龙845处理器，这颗芯片基于10nm LPP工艺制程打造，采用Kryo 385架构、八核心设计，CPU主频为2.8GHz，GPU为Adreno 630，配备4GB LPDDR4X内存+64/128GB UFS闪存，后置1200万+前置800万像素摄像头组合，电池容量为3000mAh，支持IP68级防尘防水。"
          ]
        },
        {
          title: "外媒：高通准备退出服务器芯片市场",
          time: "2018-05-08",
          pList: [
            "5 月 8 日早间消息，据彭博社报道，高通准备退出服务器芯片业务。",
            "据了解，高通是去年 11 月正式进军服务器芯片市场的，高通当时涉足服务器芯片，原本是为了打破英特尔在这个利润丰厚的市场所占据的主导地位——英特尔在这一领域大约占据 99% 的市场份额。",
            "高通当时表示，公司已开始销售一款比对手产品更出色的新服务器处理器，而这款名叫 Centriq 2400 服务器芯片采用了 ARM 的技术，由三星电子制造，高通称，Centriq 2400 在能效和成本上比英特尔的至强 Platinum 8180 更优越。",
            "当时，高通表示该新服务器处理器，并获得了谷歌公司等一些行业大型服务器芯片买家的支持。而且，微软还上台表达了对这款芯片的兴趣。但在此之后，高通一直对进度保持沉默。",
            "直到近日，彭博社援引消息人士称，高通正在研究关闭或者出售该部门。",
            "如果报道属实的话，仅仅半年左右，高通服务器芯片计划便草草收场，到底是为什么呢?虽然目前高通发言人拒绝对此消息置评。但据彭博社今年 4 月报道，高通甚至已经开始在加利福尼亚州进行裁员， 计划裁员大约 1500 人 ，以履行公司向投资者提供 10 亿美元储蓄的承诺。另外，高通 CEO 史蒂夫·莫伦科普夫(Steve Mollenkopf)在上月的财报电话会议上表示，高通的重点是压缩非核心产品领域的开支。"
          ]
        },
        {
          title: "骁龙845加持！小米8曝光：6月上市",
          time: "2018-05-11",
          pList: [
            "5月11日，业内人士摩卡RQ透露，一直被米粉和用户惦记的小米年度当家旗舰，将于本月底发布。该机将于6月上市发售，不过适逢小米八周年，这款手机的型号命名为小米8，而不是大家说的小米7。",
            "根据此前曝光的消息，小米7有望搭载3D结构光技术，正面拥有类似iPhone X的刘海设计，其原理是结构光投射特定的光信息到物体表面后，由摄像头采集。根据物体造成的光信号的变化来计算物体的位置和深度等信息，进而复原整个三围空间。",
            "配置方面，小米8将搭载骁龙845处理器，这颗芯片基于10nm LPP工艺制程打造，采用Kryo 385架构、八核心设计，CPU主频达到了2.8GHz，GPU为Adreno 630，安兔兔跑分达到了27万分。"
          ]
        },
        {
          title: "厉害了！天河新一代超算要来 计算能力提升200倍",
          time: "2018-05-11",
          pList: [
            "中国的超算已经处于世界领先水平，而天河二号更是力压一众对手，长时间保持领先地位，这都是相当难的事情。",
            "据人民日报报道称，“天河”新一代百亿亿次超级计算机原型系统将于今年完成部署，届时它的运算能力将比现有最快的超算运算能力提升一个新的等级。",
            "据悉，“天河”新一代超算的计算能力是“天河一号”超算200倍，计算密度、单块计算芯片计算能力、内部数据通信速率等方面也将得到极大提升。",
            "按照之前天河二号研究中心专家介绍称，今年年底天河二号将使用全新的国产Matrix 2000加速器，替换原有的Intel加速器，天河二号因此将全完成为国产超算，其最大运算速度也将大大提升，有希望达到每秒10亿亿次，是目前性能的几乎三倍。"
          ]
        },
        {
          title: "革命性次世代旗舰！锤子坚果R1配置公布",
          time: "2018-05-11",
          pList: [
            "5月15日也就是下周二，锤子科技将在能够容纳万人的鸟巢发布新机坚果R1。",
            "据人民日报报道称，“天河”新一代百亿亿次超级计算机原型系统将于今年完成部署，届时它的运算能力将比现有最快的超算运算能力提升一个新的等级。",
            "罗永浩已经不止一次地强调，R1将是一款革命性产品，堪称“次世代旗舰”，可以说是不怕发布后大家有落差，而是生怕无法吊足胃口。",
            "坚果R1定位高端，将有自信PK任何一个竞争对手。",
            "配置方面，吴德周确认，坚果R1搭载骁龙845芯片，拥有更大的屏占比及大幅提升的拍照性能，包括加入无线快充、线性马达等。",
            "系统方面，坚果R1探索了一些有趣且实用的AI场景，当然更重磅的是“工业设计和人性化交互”。",
            "从他的口吻来判断，坚果R1所谓的“革命”应该还是立足于软件层面的，当然，以锤子科技的秉性，依然可能是障眼法。",
            "目前，坚果R1已经在官网和京东开启了盲约，其中京东平台的人数截稿时接近7万。"
          ]
        }
      ]
    };
  },
  created() {},

  components: {
    LoginNavigator,
    LogoHeader
  }
};
</script>
<style scoped>
.container {
  width: 100%;
  background: #f5f5f5;
}
footer {
  height: 100px;
  width: 100%;
  background: #fafafa;
}
.bread {
  width: 1200px;
  height: 57px;
  line-height: 57px;
  margin: 0 auto;
  background: #fff;
}
.bread .index {
  margin-left: 24px;
}
.bread span {
  font-size: 12px;
  color: #333;
}
.bread .current {
  color: #00a0e9;
}
.main {
  width: 1200px;
  margin: 0 auto;
  background: #fff;
}
.main .main-content ul li {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 40px;
  border-bottom: 1px solid #f5f5f5;
}
.main .main-content ul a {
  width: 100%;
}
.main .main-content ul .title {
  display: inline-block;
}
</style>


// WEBPACK FOOTER //
// src/views/morenews.vue